import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { Box, Typography, Stack, Chip, useMediaQuery } from "@mui/material";
import { useThemeContext } from "../../Context/ThemeContext";
import { useTranslation } from "react-i18next";
import { DARKCOLORS, LIGHTCOLORS } from "../../Utils/constants";
import { min } from "date-fns";

const RevenuePieChart = ({ revenueData }) => {
    const { mode } = useThemeContext();
    const { t } = useTranslation();

    const backgroundCard = mode === 'dark' ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;
    const typeColor1 = mode === 'dark' ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;
    const typeColor2 = mode === 'dark' ? DARKCOLORS.Secondary500 : LIGHTCOLORS.Secondary500;
    const typeColor3 = mode === 'dark' ? DARKCOLORS.Warning500 : LIGHTCOLORS.Warning500;
    const typeColor4 = mode === 'dark' ? DARKCOLORS.Danger500 : LIGHTCOLORS.Danger500;
    const textColor1 = mode === 'dark' ? DARKCOLORS.BaseWhite : LIGHTCOLORS.BaseWhite;
    const textColor2 = mode === 'dark' ? DARKCOLORS.BaseBlack : LIGHTCOLORS.BaseBlack;
    const isMobile = useMediaQuery('(max-width:500px)'); //
    const generatePieChartColors = (count) => {
        const colorPalette = [typeColor1, typeColor2, typeColor3, typeColor4];
        const textColorPalette = [textColor1, textColor2, textColor2, textColor1];

        return {
            backgroundColors: Array.from({ length: count }, (_, i) => colorPalette[i % colorPalette.length]),
            textColors: Array.from({ length: count }, (_, i) => textColorPalette[i % textColorPalette.length])
        };
    };

    const revenuePieChartData = Object.keys(revenueData).map(paymentType => ({
        name: paymentType,
        value: revenueData[paymentType]
    }));

    const totalRevenue = revenuePieChartData.reduce((sum, entry) => sum + entry.value, 0);
    const { backgroundColors, textColors } = generatePieChartColors(revenuePieChartData.length);


    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div
                    style={{
                        background: backgroundCard,
                        filter: 'drop-shadow(0px 2.541px 20.324px rgba(75, 85, 110, 0.20))',
                        padding: "10px 5px",
                        borderRadius: "5px",
                        boxShadow: "0px 0px 5px rgba(0,0,0,0.2)",
                    }}
                >
                    <p className="add-machine" style={{ margin: "0px" }}>€ {payload[0].value.toFixed(2)}</p>
                </div>
            );
        }
        return null;
    };
    return (
        <Box sx={{ padding: "20px", background: backgroundCard, borderRadius: "12px", width: "100%", }}>
            <p className="machine-name-text"> {t('taxes.RevenueBreakdown')}</p>

            <Box  sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%", }}>
                {/* Left Side - Payment Types */}
                <Stack spacing={2} sx={{ flex: 1 }}>
                    {revenuePieChartData.map((entry, index) => (
                        <Chip
                            key={entry.name}
                            label={entry.name}
                            sx={{
                                backgroundColor: backgroundColors[index],
                                color: textColors[index],
                                padding: "6px 12px 7px 12px",
                                borderRadius: "6px",
                                margin: "1rem 0rem !important",
                            }}
                            className="machine-name-text"
                        />
                    ))}
                </Stack>

                {/* Right Side - Pie Chart */}
                <Box sx={{ flex: 2, position: "relative" }}>
                    <ResponsiveContainer height={290} sx={{ width: "100%",minWidth:'none' }}>
                        <PieChart>
                            <Pie
                                data={revenuePieChartData.length ? revenuePieChartData : [{ name: "No Data", value: 1 }]}
                                cx="50%"
                                cy="50%"
                                innerRadius={isMobile?75:95}
                                outerRadius={isMobile?100:125}
                                paddingAngle={3}
                                dataKey="value"
                                stroke="none"
                            >
                                {revenuePieChartData.length ? revenuePieChartData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={backgroundColors[index % backgroundColors.length]} />
                                )) : <Cell fill="#B0B0B0" />}
                            </Pie>
                            <Tooltip content={<CustomTooltip />} />
                        </PieChart>
                    </ResponsiveContainer>

                    {/* Centered Total Revenue */}
                    <Typography
                        variant="h5"
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            textAlign: "center",
                        }}
                        className="subheading-sec-card"
                    >
                        € {totalRevenue.toFixed(2)}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default RevenuePieChart;
